<template>
    <footer v-if="content" class="footer">
        <div div="container">
          <div class="footer__container">
              <div class="home__grid__credit-text">Website by <a href="https://detailsofwar.com/" target="_blank" rel="noopener noreferrer">Details of War</a></div>
              <router-link class="footer__logo" to="/">lof</router-link>
              <section class="footer__content">
                  <div class="footer__about">
                      <p class="footer__about__text" v-html="content.description"></p>
                  </div>
                  <div v-if="isMobile" class="footer__buttons__about">
                      <AppButton link="/about" text="Learn more about us" spaces="right" />
                  </div>
                  <div class="footer__newsletter">
                      <AppSplitLinesElem ref="splitDescription">
                          <p class="footer__newsletter__text" v-html="content.subscribe" ref="splitElem"></p>
                      </AppSplitLinesElem>
                  </div>
              </section>
          </div>
          <section class="footer__buttons">
              <div class="footer__container">
                  <div v-if="!isMobile" class="footer__buttons__about">
                      <AppButton link="/about" text="Learn more about us" spaces="right" />
                  </div>
                  <div class="footer__buttons__newsletter">
                      <div class="footer__buttons__newsletter__input" :class="{'is-loading': mail.loading}">
                          <input class="link--btn" placeholder="your email" aria-label="email field" ref="input">
                          <button class="input--btn__ok" @click="onClickSubscribe">
                              <span v-if="!mail.loading">Ok</span>
                              <span v-else class="input--btn__ok__spinner"></span>
                          </button>
                      </div>
                      <div class="footer__buttons__newsletter__text" :class="{'has-error': mail.type === 'error', 'has-success': mail.type === 'success'}" v-if="mail.message">
                          {{ mail.message }}
                      </div>
                  </div>
              </div>
          </section>
        </div>
        <section class="footer__socials">
            <div class="footer__container footer__links-container">
                <ul class="footer__links">
                    <template v-for="(item, index) in content.social_links">
                        <li class="footer__link" :key="index">
                            <a class="link" :href="item.url"> {{ item.text }} </a>
                        </li>
                    </template>
                </ul>
                <p class="footer__terms">
                    <router-link class="link" to="/terms"> terms & conditions</router-link>
                </p>
            </div>
        </section>
    </footer>
</template>

<script>
import EventHub from '@/utils/EventHub'

import AppButton from '@/components/AppButton'
import AppSplitLinesElem from '@/components/AppSplitLinesElem.vue'

export default {
  name: 'app-footer',

  components: {
      AppButton,
      AppSplitLinesElem
  },

  data() {
    return {
        content: null,
        isMobile: false,
        mail: {
            loading: false,
            message: null,
            type: null
        }
    }
  },

  created() {
      const endpoint = '/wp-json/acf/v3/pages/39'
      this.loadDatas(endpoint, () => {
        this.$nextTick(() => {
            this.$refs.splitDescription.initSplitLines(this.$refs.splitElem)
        })
      })

      EventHub.$on('window:resize', this.onResize)
  },

  mounted() {

  },

  destroyed()
  {
    EventHub.$off('window:resize', this.onResize)
  },

  methods: {
    loadDatas(endpoint, callback)
    {
        fetch(process.env.VUE_APP_WP_API + endpoint)
        .then((res) => res.json())
        .then((res) =>
        {
            // console.log('footer data loaded', this.content)
            this.content = res.acf
            callback()
        })
    },

    onClickSubscribe()
    {
        if(this.$refs.input.value.length === 0 || this.mail.loading)
            return

        const url = process.env.VUE_APP_WP_API + '/subscribe/subscribe.php'

        this.mail.type = null
        this.mail.message = null

        let formData = new FormData()
        formData.append('email', this.$refs.input.value)

        this.mail.loading = true

        fetch(url, 
        {
            method: 'POST', 
            body: formData
        })
        .then((res) => res.json())
        .then((res) =>
        {
            this.$refs.input.value = ''

            this.mail.loading = false

            if(res.error === 0)
            {
                this.mail.type = 'success'
                this.mail.message = 'You are now registered!'

                setTimeout(() => {
                    this.mail.type = null
                    this.mail.message = null
                }, 5000)
            }
            else
            {
                this.mail.type = 'error'
                this.mail.message = res.detail
            }
        })
    },

    onResize(windowObj)
    {
        if(windowObj.width <= 768)
        {
            this.isMobile = true
        }
        else
        {
            this.isMobile = false
        }
    },
  }
}
</script>

<style lang="stylus">
    .container
        position relative

    .home__grid__credit-text
        position absolute
        top 50%
        // left -5%
        text-transform uppercase
        transform-origin 0 0
        transform rotate(-90deg) translateX(-25%) translateY(-100%)
        & a
            text-decoration underline

    .footer
    
        position relative
        z-index 4
        width 100%
        interpolate('margin-top', 1600px, 2560px, 250px, 360px);

        @media(max-width 1600px)
            interpolate('margin-top', 768px, 1600px, 120px, 250px);

        @media(max-width 768px)
            margin-top 80px

    .footer__container
        width 100%
        padding 0 $space-x

        @media(max-width 768px)
            padding 0 $space-x-mobile

    .footer__links-container
        display flex
        justify-content space-between
        // align-items center

    .footer__content
        width 100%
        display flex
        flex-direction row
        justify-content space-between
        interpolate('margin-bottom', 1600px, 2560px, 70px, 100px);

        @media(max-width 1600px)
            interpolate('margin-bottom', 768px, 1600px, 30px, 70px);

        @media(max-width 768px)
            flex-direction column

    .footer__about, .footer__buttons__about
        width calc(100% / 36 * 20)
        padding-left calc(100% / 36)

        @media(max-width 768px)
            width 100%
            padding-left 0

    .footer__logo
        padding-left calc(100% / 36)
        display block
        font-family 'Sabon'
        // font-size 87px
        line-height 1
        text-transform uppercase
        interpolate('font-size', 1600px, 2560px, 120px, 172px);
        interpolate('margin-bottom', 1600px, 2560px, 70px, 100px);

        @media(max-width 1600px)
            interpolate('font-size', 768px, 1600px, 58px, 120px);
            interpolate('margin-bottom', 768px, 1600px, 30px, 70px);

        @media(max-width 768px)
            margin-bottom 40px
            padding-left 0

    .footer__about__text
        text-transform uppercase
        line-height 1.35
        interpolate('font-size', 1600px, 2560px, 25px, 35px);

        @media(max-width 1600px)
            interpolate('font-size', 768px, 1600px, 15px, 25px);

        @media(max-width 768px)
            margin-bottom 45px

    .footer__newsletter, .footer__buttons__newsletter
        width calc(100% / 36 * 13)

        @media(max-width 768px)
            width calc(100% / 16 * 15)

    .footer__buttons__newsletter__input
        width 100%
        display flex

        &.is-loading
            opacity 0.3

    .footer__newsletter__text
        font-size 42px
        line-height 0.9
        interpolate('font-size', 1600px, 2560px, 60px, 84px);

        @media(max-width 1600px)
            interpolate('font-size', 768px, 1600px, 30px, 60px);

        @media(max-width 768px)
            font-size 28px

    
    .footer__buttons
        margin-bottom 60px
        interpolate('margin-bottom', 1600px, 2560px, 60px, 120px);

        @media(max-width 1600px)
            interpolate('margin-bottom', 768px, 1600px, 50px, 60px);

        .footer__container
            display flex
            justify-content space-between

    .footer__buttons__about
        
        @media(max-width 768px)
            margin-bottom 65px

    .footer__buttons__newsletter
        position relative
        display flex
        flex-direction column

        .link--btn
            width 60%
            min-width 200px

            @media(max-width 768px)
                width 70%

        .input--btn__ok
            border-left 0px

    .footer__buttons__newsletter__text
        // position absolute
        display block
        margin-top 30px
        font-size 15px

        &.has-error
            color #cf0015

    .footer__socials
        border-top 1px solid $black

    .footer__links
        padding 60px 0 60px calc(100% / 36)
        display flex
        flex-wrap nowrap
        interpolate('padding-bottom', 1600px, 2560px, 60px, 100px);
        interpolate('padding-top', 1600px, 2560px, 60px, 100px);

        @media(max-width 1600px)
            interpolate('padding-bottom', 768px, 1600px, 30px, 60px);
            interpolate('padding-top', 768px, 1600px, 30px, 60px);

        @media(max-width 768px)
            flex-wrap wrap
            padding 40px 0
    
    .footer__link
        margin-right 50px
        interpolate('font-size', 1600px, 2560px, 25px, 35px);

        @media(max-width 1600px)
            interpolate('font-size', 768px, 1600px, 15px, 25px);

        @media(max-width 768px)
            margin-right 30px

        &:last-child
            margin-right 0

    .footer__terms
        padding 60px
        text-transform uppercase
        interpolate('font-size', 1600px, 2560px, 25px, 35px);
        interpolate('padding-bottom', 1600px, 2560px, 60px, 100px);
        interpolate('padding-top', 1600px, 2560px, 60px, 100px);

        @media(max-width 1600px)
            interpolate('font-size', 768px, 1600px, 15px, 25px);
            interpolate('padding-bottom', 768px, 1600px, 30px, 60px);
            interpolate('padding-top', 768px, 1600px, 30px, 60px);

        @media(max-width 768px)
            padding 40px 0
</style>